<template>
  <div class="pdf-file">
    <el-tabs ref="gradeTab" class="grade-tab" v-model="activeTabName" @tab-click="handlerTabClick">
      <el-tab-pane name="tab-personal" v-if="examInfo.exam_paper_type !== 'NOTE' && examInfo.stat !== 'N'">
        <span slot="label" class="gray label">개인 성적표</span>

        <div class="print-grade-personal">
          <div class="card">
            <div class="card-body">
              <div class="media logo">
                <img src="/static/img/logo_notext.png" />
                <div class="media-body">
                  <h2>개인 성적표</h2>
                </div>
              </div>
              <div class="d-flex with-media">
                <div class="p-2 w-100">
                  <div class="media">
                    <img :src="examInfo.picture_path ? examInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
                    <div class="media-body">
                      <h5>{{examInfo.class_user_name}}  <span class="badge rose align-middle">{{examInfo.cate_path}}</span></h5>
                      <p><span class="gray">클래스</span> <strong>{{examInfo.class_name}}</strong></p>
                    </div>
                  </div>
                </div>
                <div class="ml-auto p-2 rank text-nowrap">
                  <span class="number"><strong>{{examInfo.exam_rank}}</strong></span> / <span class="numbe1">{{examInfo.entry_cnt}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="card second-card">
            <div class="card-body">
              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1 class="title">{{examInfo.exam_title}}</h1>
                  <p>
                    <span class="gray">시험유형</span> <strong>{{examInfo.exam_paper_type_name}}</strong>
                    <span class="gray"> · 시험일자</span> <strong>{{examInfo.open_dt}}</strong>
                    <span class="gray"> · 클래스</span> <strong>{{examInfo.class_name}}</strong>
                    <template v-if="examInfo.curriculum_yn === 'Y'">
                      <span class="gray"> · 커리큘럼</span> <strong>{{examInfo.curriculum_name}}</strong>
                      <span class="gray"> · 회차</span> <strong>{{examInfo.times}}회차</strong>
                    </template>
                  </p>
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <data-tables ref="tabGroupTable" :data="groupData" :table-props="tableProps" :pagination-props="emptyPaginationProps" :page-size="emptyPageSize" v-loading="searchLoading">
                      <el-table-column v-for="(column, index) in groupColumns" :key="'row_' + index" header-align="center"
                        :prop="column.prop" :label="column.label" :align="column.align" :min-width="column.width" :label-class-name="'stone-table-label '" :class-name="'stone-table-cell ' + column.class" :formatter="column.formatter">
                        <template slot-scope="scope">
                          <span class="number">{{ scope.row[column.prop] }}</span><br />
                          <span class="number" v-if="column.prop !== 'cate_code_name'">{{ `(${scope.row[column.prop + '_100']})` }}</span>
                        </template>
                      </el-table-column>
                    </data-tables>
                    <!-- <stone-data-table
                      ref="tabGroupTable"
                      :loading="searchLoading"
                      :columns="groupColumns"
                      :data="groupData"
                      :table-props="tableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table> -->
                  </fieldset>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>영역별 성적 비교</h2>
                      </div>
                      <div class="p-2 ml-auto">
                      <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <bar-chart :chart-data="barChartData" :height="barChartHeight" :options="barChartOptions" :styles="barChartStyles"></bar-chart>
                  </fieldset>
                </el-col>
              </el-row>

              <template v-if="graphVisible">
                <el-row :gutter="40">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <fieldset v-if="lineVisible">
                      <div class="d-flex">
                        <div class="p-2">
                          <h2>성적 변화 그래프</h2>
                        </div>
                        <div class="p-2 ml-auto">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                        </div>
                      </div>
                      <line-chart :chart-data="lineChartData" :height="lineChartHeight" :options="lineChartOptions" :styles="lineChartStyles"></line-chart>
                    </fieldset>
                    <fieldset v-if="radarVisible">
                      <div class="d-flex">
                        <div class="p-2">
                          <!-- <h2>영역별 누적 분석</h2> -->
                        </div>
                        <div class="p-2 ml-auto">
                        <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                        </div>
                      </div>
                      <radar-chart :chart-data="radarChartData" :height="radarChartHeight" :options="radarChartOptions" :styles="radarChartStyles"></radar-chart>
                    </fieldset>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <fieldset>
                      <div class="d-flex">
                        <div class="p-2">
                          <h2>취약유형 분석</h2>
                        </div>
                        <div class="p-2">
                          <strong><span class="number mint"></span></strong>
                        </div>
                      </div>
                      <stone-data-table
                        :loading="searchLoading"
                        :columns="groupWrongColumns"
                        :data="quizWrongData"
                        :table-props="quizTableProps"
                        :page-size="emptyPageSize"
                        :pagination-props="emptyPaginationProps">
                      </stone-data-table>
                    </fieldset>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <fieldset>
                  <div class="d-flex">
                    <div class="p-2">
                      <h2>취약유형 분석</h2>
                    </div>
                    <div class="p-2">
                      <strong><span class="number mint"></span></strong>
                    </div>
                  </div>
                  <stone-data-table
                    :loading="searchLoading"
                    :columns="groupWrongColumns"
                    :data="quizWrongData"
                    :table-props="quizTableProps"
                    :page-size="emptyPageSize"
                    :pagination-props="emptyPaginationProps">
                  </stone-data-table>
                </fieldset>
              </template>

            </div>

          </div>

        </div>

        <div class="print-grade-personal">

          <div class="card second-card">

            <div class="card-body">

              <fieldset>
                <div class="d-flex">
                  <div class="p-2">
                    <h2>문항 분석</h2>
                  </div>
                  <div class="p-2">
                    <strong><span class="number mint"></span></strong>
                  </div>
                </div>
                <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                  <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                    <template v-for="t in quizSplitCount">
                        <thead :key="'th_1_' + t" class="has-gutter">
                        <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * itemCount">
                          <th class="is-center stone-table-cell stone-table-label">문항</th>
                          <th v-for="i in itemCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                            <span class="number" v-if="quizData[idx]">{{quizData[idx].display_no}}</span>
                          </th>
                        </tr>
                        </thead>
                        <tr :key="'tr_2_' + t">
                          <th class="is-center stone-table-cell stone-table-label">채점표</th>
                          <td v-for="i in itemCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionClassName(quizData[idx].solution_yn)">{{getSolutionName(quizData[idx].solution_yn)}}</span>
                          </td>
                        </tr>
                        <tr :key="'tr_3_' + t">
                          <th class="is-center stone-table-cell stone-table-label">정답률</th>
                          <td v-for="i in itemCount" :key="'td_3_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{formatterPrecision(quizData[idx].solution_rate)}}</span>
                          </td>
                        </tr>
                        <tr :key="'tr_4_' + t">
                          <th class="is-center stone-table-cell stone-table-label">영역</th>
                          <td v-for="i in itemCount" :key="'td_4_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell">
                            <span v-if="quizData[idx]" :class="getSolutionRateClassName(quizData[idx].solution_yn)">{{quizData[idx].group_cate_code_name}}</span>
                          </td>
                        </tr>
                    </template>
                  </table>
                </div>
              </fieldset>

              <fieldset>
                <h2>선생님 의견</h2>
                <div v-html="replaceCarriageReturnToBr(examInfo.exam_comment)"></div>
              </fieldset>

            </div>

          </div>

        </div>

      </el-tab-pane>

      <!-- 오답노트가 아니고, 시험이 종료되었고, 회차가 있을 경우에만 종합 성적표 탭을 보여준다. -->
      <el-tab-pane name="tab-total" v-if="examInfo.exam_paper_type !== 'NOTE' && examInfo.stat !== 'N' && examInfo.curriculum_yn === 'Y' && examInfo.times > 0">
        <span slot="label" class="gray label">종합 성적표</span>

        <div class="print-grade-total">
          <div class="card">
            <div class="card-body">
              <div class="media logo">
                <img src="/static/img/logo_notext.png" />
                <div class="media-body">
                  <h2>종합 성적표</h2>
                </div>
              </div>
              <div class="d-flex with-media">
                <div class="p-2 w-100">
                  <div class="media">
                    <img :src="examInfo.picture_path ? examInfo.picture_path : '/static/img/user@3x.png'" class="avatar" />
                    <div class="media-body">
                      <h5>{{examInfo.class_user_name}}  <span class="badge rose align-middle">{{examInfo.cate_path}}</span></h5>
                      <p><span class="gray">클래스</span> <strong>{{examInfo.class_name}}</strong></p>
                    </div>
                  </div>
                </div>
                <div class="ml-auto p-2 rank text-nowrap">
                  <!-- <span class="number"><strong>{{examInfo.exam_rank}}</strong></span>등 / <span class="numbe1">{{examInfo.entry_cnt}}</span> -->
                </div>
              </div>
            </div>
          </div>
          <div class="card second-card">
            <div class="card-body">
              <div class="d-flex blue-gray">
                <div class="p-2">
                  <h1 class="title">{{examInfo.book_name}}</h1>
                  <p>
                    <!-- <span class="gray">시험유형</span> <strong>{{examInfo.exam_paper_type_name}}</strong>
                    <span class="gray"> · 시험일자</span> <strong>{{examInfo.open_dt}}</strong>
                    <span class="gray"> · 클래스</span> <strong>{{examInfo.class_name}}</strong>
                    <template v-if="examInfo.curriculum_yn === 'Y'">
                      <span class="gray"> · 커리큘럼</span> <strong>{{examInfo.curriculum_name}}</strong>
                      <span class="gray"> · 회차</span> <strong>{{examInfo.times}}회차</strong>
                    </template> -->
                  </p>
                </div>
              </div>

              <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition user-table-times">
                      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                        <template v-for="t in examTotalTimesSplitCount">
                            <thead :key="'th_1_' + t" class="has-gutter">
                            <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * examTotalTimesCount">
                              <th class="is-center stone-table-cell stone-table-label"></th>
                              <th v-for="i in examTotalTimesCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                                <span class="number" v-if="examTotalTimesData[idx]">{{examTotalTimesData[idx].times}}회차</span>
                              </th>
                            </tr>
                            </thead>
                            <tr :key="'tr_2_' + t">
                              <th class="is-center stone-table-cell stone-table-label number">내점수 / 배점<br />(백분위 점수)</th>
                              <td v-for="i in examTotalTimesCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell td-times">
                                <div class="number" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'"><strong>{{examTotalTimesData[idx].exam_score}}</strong> / {{examTotalTimesData[idx].quiz_score}}</div>
                                <div class="number" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'">{{`(${examTotalTimesData[idx].exam_score_100})`}}</div>
                              </td>
                            </tr>
                        </template>
                      </table>
                    </div>
                  </fieldset>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>석차 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <div class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition user-table-times">
                      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
                        <template v-for="t in examTotalTimesSplitCount">
                            <thead :key="'th_1_' + t" class="has-gutter">
                            <tr :key="'tr_1_' + t" :with="trIdx = (t - 1) * examTotalTimesCount">
                              <th class="is-center stone-table-cell stone-table-label"></th>
                              <th v-for="i in examTotalTimesCount" :key="'td_1_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell stone-table-label">
                                <span class="number" v-if="examTotalTimesData[idx]">{{examTotalTimesData[idx].times}}회차</span>
                              </th>
                            </tr>
                            </thead>
                            <tr :key="'tr_2_' + t">
                              <th class="is-center stone-table-cell stone-table-label number">석차 / 전체</th>
                              <td v-for="i in examTotalTimesCount" :key="'td_2_' + (t * i)" :with="idx = i + trIdx - 1" class="is-center stone-table-cell td-times">
                                <div class="number" v-if="examTotalTimesData[idx] && examTotalTimesData[idx].exam_user_stat === 'S'"><strong>{{examTotalTimesData[idx].exam_rank}}</strong> / {{examTotalTimesData[idx].entry_cnt}}</div>
                              </td>
                            </tr>
                        </template>
                      </table>
                    </div>
                  </fieldset>
                </el-col>
              </el-row>

              <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>성적 변화 그래프</h2>
                      </div>
                      <div class="p-2 ml-auto">
                      <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <line-chart :chart-data="lineChartData" :height="timesLineChartHeight" :options="lineChartOptions" :styles="timesLineChartStyles"></line-chart>
                  </fieldset>
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <!-- <h2>영역별 누적 분석</h2> -->
                      </div>
                      <div class="p-2 ml-auto">
                      <img src="/static/img/mint-circle.svg" /> 내점수 <img src="/static/img/navy-circle.svg" /> 평균점수
                      </div>
                    </div>
                    <radar-chart :chart-data="radarTotalChartData" :height="timesRadarChartHeight" :options="radarChartOptions" :styles="timesRadarChartStyles"></radar-chart>
                  </fieldset>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <fieldset>
                    <div class="d-flex">
                      <div class="p-2">
                        <h2>취약유형 분석</h2>
                      </div>
                      <div class="p-2">
                        <strong><span class="number mint"></span></strong>
                      </div>
                    </div>
                    <!-- 그리드 -->
                    <stone-data-table
                      :loading="searchLoading"
                      :columns="groupWrongColumns"
                      :data="quizWrongTotalData"
                      :table-props="quizTableProps"
                      :page-size="emptyPageSize"
                      :pagination-props="emptyPaginationProps">
                    </stone-data-table>
                  </fieldset>
                </el-col>
              </el-row>

            </div>

          </div>

          <div class="card second-card">
            <div class="card-body">
              <fieldset>
                <h2>선생님 의견</h2>
                <div v-html="replaceCarriageReturnToBr(examInfo.exam_times_comment)"></div>
              </fieldset>
            </div>
          </div>
        </div>

        <!-- <div class="print-grade-total">
        </div> -->
      </el-tab-pane> <!-- 종합성적표 end-->

    </el-tabs>

  </div>
</template>

<script>

import 'element-ui/lib/theme-chalk/display.css'
import common from '@/modules/common'
import grade from '@/modules/grade'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  name: 'R010202',
  mixins: [common.mixins, grade],
  props: {
    isCreate: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      isLocalCreate: this.isCreate,
      itemCount: 20,
      activeTabName: 'tab-personal',
      examTotalTimesCount: 4,
      isResultZip: false
    }
  },
  mounted () {
    // this.handleWindowResize()
    // window.addEventListener('resize', this.handleWindowResize)
  },
  beforeDestroy: function () {
    // window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    created () {
      if (this.isLocalCreate && this.$route.params) {
        this.param = {
          exam_seq: this.getToNumber(this.$route.params.exam_seq),
          class_seq: this.getToNumber(this.$route.params.class_seq),
          class_user_seq: this.getToNumber(this.$route.params.class_user_seq)
        }
        this.loadInfo()
        this.loadExamUserComment()
      }
    },
    initPersonalPrint (params, isPrint, activeTabName) {
      this.param = {
        exam_seq: this.getToNumber(params.exam_seq),
        class_seq: this.getToNumber(params.class_seq),
        class_user_seq: this.getToNumber(params.class_user_seq)
      }
      this.loadInfo()
      this.loadExamUserComment()
      if (isPrint) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.handlePDF(true, activeTabName)
          }, 1000)
        })
      }
    },
    initGradeTotal (params) {
      this.activeTabName = 'tab-total'
      this.param = {
        exam_seq: this.getToNumber(params.exam_seq),
        class_seq: this.getToNumber(params.class_seq),
        class_user_seq: this.getToNumber(params.class_user_seq)
      }
      // console.log('this.param : ', this.param)
      this.loadInfo(false)
      this.loadExamUserComment()
    },
    loadExamUserComment () {
      common.axios.post('/grade/exam/user/comment', this.param)
        .then(response => {
          const result = response.data
          this.examInfo.exam_comment = result.exam_comment
          this.examInfo.exam_times_comment = result.exam_times_comment
        })
    },
    // 시험 정보 조회
    loadInfo (isPersonal = true) {
      // 현재 시험 정보 조회
      common.axios.post('/grade/exam/user', this.param)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.examInfo).forEach(key => {
            this.examInfo[key] = this.isEmpty(result[key]) ? '' : result[key]
          })
          // 오답노트이거나 종료되지 않은 시험은 채점표만 보여준다.
          if (result.exam_paper_type === 'NOTE' || (result.close_yn === 'N' && result.stat !== 'C')) {
            this.$refs.gradeTab.$el.children[0].style.display = 'none'
            return
          }
          // 모의고사 일때는 스파이더 차트를 보여준다
          if (result.exam_paper_type === 'TEST') {
            // 커리큘럼이 없는 경우 스파이더 차트 크기를 늘려준다.
            if (result.curriculum_yn === 'N') {
              this.lineVisible = false
              this.radarChartHeight = 442
            } else {
              this.timesVisible = true
            }
          } else {
            this.radarVisible = false
            if (result.curriculum_yn === 'Y') {
              this.graphVisible = true
              this.lineChartHeight = 418
              this.timesVisible = false
            } else {
              this.graphVisible = false
              // this.lineVisible = false
            }
          }
          // 종합성적표만 보일 경우에는 개인 성적표를 조회하지 않는다.
          if (isPersonal) {
            // 개인 성적표
            this.loadExamGrade()
          }
          // 종합 성적표 조회 (누적 회차별)
          if (result.curriculum_yn === 'Y') {
            this.loadExamGradeTotalTimes()
          }
        })
    },
    handlePDF (isZip = false, activeTabName = '') {
      this.isResultZip = isZip
      if (activeTabName) {
        this.activeTabName = activeTabName
      }
      this.$nextTick(() => {
        setTimeout(() => {
          const currentTab = this.$refs.gradeTab.currentName
          this.makePDF('.print-grade-' + (currentTab === 'tab-personal' ? 'personal' : 'total'))
        }, 1000)
      })
    },
    makePDF (selector) {
      // this.pdfLoading = true
      this.$nextTick(() => {
        let fileName = ''
        if (selector === '.print-grade-personal') {
          // 개인성적표
          fileName = '개인_' + this.examInfo.class_user_name + '_' + this.examInfo.exam_title
        } else {
          // 종합성적표
          fileName = '종합_' + this.examInfo.class_user_name + '_' + this.examInfo.book_name
        }
        this.exportPDF(selector, fileName)
      })
    },
    exportPDF (selector = 'body', filename = 'filename') {
      // window.html2canvas = html2canvas // Vue.js 특성상 window 객체에 직접 할당해야한다.
      const that = this
      // let pdf = new JsPDF('p', 'mm', 'a4')
      // let canvas = pdf.canvas
      const pageWidth = 210 // 캔버스 너비 mm
      const pageHeight = 295 // 캔버스 높이 mm
      // canvas.width = pageWidth
      const elem = document.querySelector(selector)
      // const width = elem.offsetWidth // 셀렉트한 요소의 px 너비
      // const height = elem.offsetHeight // 셀렉트한 요소의 px 높이
      // const imgHeight = pageWidth * height / width // 이미지 높이값 px to mm 변환
      if (!elem) {
        console.warn(selector + ' is not exist.')
        return false
      }
      // console.log('window.devicePixelRatio: ', window.devicePixelRatio)
      // 프린트 페이지를 강제로 클래스 배열 단위로 구분하여 처리한다.
      const elems = document.querySelectorAll(selector)
      const promises = []
      elems.forEach(item => {
        promises.push(html2canvas(item, {scale: 2, logging: false}))
      })

      // Promise.all를 사용하여 element를 일괄로 처리해준다.
      Promise.all(promises).then(result => {
        // console.log('result : ', result)
        const pdf = new JsPDF()
        pdf.setFillColor('#e7ebf1')
        pdf.rect(0, 0, 210, 300, 'F')
        let position = 5
        let index = 0
        result.forEach(canvas => {
          const width = elems[index].offsetWidth // 셀렉트한 요소의 px 너비
          const height = elems[index].offsetHeight // 셀렉트한 요소의 px 높이
          const imgHeight = pageWidth * height / width // 이미지 높이값 px to mm 변환
          if (index > 0) {
            position += 5
            pdf.addPage()
            pdf.setFillColor('#e7ebf1')
            pdf.rect(0, 0, 210, 300, 'F')
          }
          const imgData = canvas.toDataURL('image/png')
          pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight, undefined, 'slow') // Paging 처리
          let heightLeft = imgHeight // 페이징 처리를 위해 남은 페이지 높이 세팅.
          heightLeft -= pageHeight
          index++
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight
            pdf.addPage()
            pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight)
            heightLeft -= pageHeight
            index++
          }
        })
        // console.log('this.isResultZip : ', this.isResultZip)
        if (this.isResultZip) {
          // that.pdfLoading = false
          if (that.$parent.$parent) {
            that.$parent.$parent.completedPDF(true, {name: filename + '.pdf', doc: pdf})
          }
        } else {
          pdf.save(filename + '.pdf')
          // that.pdfLoading = false
          if (that.$parent.$parent) {
            that.$parent.$parent.completedPDF(true)
          }
        }
      }).catch((err) => {
        // that.pdfLoading = false
        if (that.$parent.$parent) {
          that.$parent.$parent.completedPDF(false)
        }
        this.$message.error('PDF 다운로드 실패')
        console.error('html2canvas error : ', err)
      })
    },
    handlerTabClick () {
      if (this.activeTabName === 'tab-personal') {
        // console.log(this.$refs.tabGroupTable)
        this.$refs['tabGroupTable'].$refs.elTable.doLayout()
      }
    }
  }
}
</script>

<style>
  .grade-tab .el-tabs__item {
    width: 50%;
    text-align: center;
    height: 64px;
    line-height: 64px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/R010202.vue